import { SeenReferralTooltipCompanyIdsLocalStorageKey } from '../VenueReferAFriendButton.constants'

export const getSeenCompanyIds = (): Array<string> => {
  try {
    const stored = window.localStorage.getItem(SeenReferralTooltipCompanyIdsLocalStorageKey)
    return stored ? (JSON.parse(stored) as Array<string>) : []
  } catch {
    return []
  }
}

export const markCompanyAsSeen = (companyId: string) => {
  const seenCompanyIds = getSeenCompanyIds()
  if (seenCompanyIds.includes(companyId)) return
  window.localStorage.setItem(
    SeenReferralTooltipCompanyIdsLocalStorageKey,
    JSON.stringify([...seenCompanyIds, companyId]),
  )
}
